import React from 'react'
import styles from './Level.module.scss'
import ActionMenu from 'components/UI/ActionMenu/ActionMenu'

export const Level = ({ level, action, index, menu }) => {
  return (
    <div
      className={`${styles.reasonsContainer} ${index % 2 === 0 ? styles.colorBg : ''}`}
    >
      <div className={styles.containerInf}>
        <div className={`${styles.infStyl} ${styles.name}`}>{level.name}</div>
        <div className={styles.buttons}>
          <ActionMenu
            menu={menu}
            action={(actionType) => action(actionType, null, level)}
          />
        </div>
      </div>
    </div>
  )
}
